// CamelCase -> SnakeCase
const toUnderscoreCase = (str) => {
  return str.split(/(?=[A-Z])/).join('_').toLowerCase();
};

export default toUnderscoreCase;
